import React, {useState, useEffect} from "react";
import {useNavigate, Navigate} from "react-router-dom";
import {APIClient} from "../utils/APIClient";
import {AccessService} from "../utils/AccessService";
import {DashboardWrapper} from "./dashboard/DashboardWrapper";
import AdAccountList from "./manage_accounts/AdAccountList";
import {LocalStorage} from "../utils/LocalStorage";
import { useTranslation } from 'react-i18next';
import { McpUpgradePage } from "./upgrade_to_dashbo/mcp/McpUpgradePage";

export const Default = () => {
    const [modules, setModules] = useState(null);
    const navigate = useNavigate();
    const { t } = useTranslation();
    const isDashboMcp = LocalStorage.fetchIsDashboMcp();
    const isClientUser = LocalStorage.isClientUser();

    const getUserId = () => {
        return LocalStorage.fetchUserId();
    };

    const redirectToLogin = () => {
        navigate('/login');
    };

    useEffect(() => {
        if (isDashboMcp || isClientUser) return;

        const getUserModules = () => {
            // Mismo endpoint que pide `UserModulesProvider` al montar: con `cache` la home lo pide
            // una vez entre los dos en vez de dos veces.
            new APIClient(AccessService.GetUserModulesUrl(getUserId())).call('GET', {}, {cache: true}).then((data) => {
                if (data.status === 'ERROR_NO_AGENCY') {
                    const errors = data.errors ? JSON.parse(data.errors) : {};
                    if (errors.invitation_pending_hash) {
                        navigate('/accept-invitation/' + errors.invitation_pending_hash);
                    } else {
                        navigate('/agency-register');
                    }
                } else if (data.status === 'ERROR') {
                    alert(data['error_message']);
                    LocalStorage.removeUserData();
                    redirectToLogin();
                } else if (data.status === 'OK') {
                    setModules(data.data.modules);
                }
            });
        };

        getUserModules();
    }, []);

    // CLIENT_USER: redirigir al portal
    if (isClientUser) {
        return <Navigate to="/portal" replace />;
    }

    // Si es una agencia Dashbo MCP, mostrar pantalla de upgrade
    if (isDashboMcp) {
        return <McpUpgradePage />;
    }

    if (!modules) {
        return "";
    }

    if (modules.includes(AccessService.MODULE_MARKETING)) {
        return <DashboardWrapper />;
    } else if (modules.includes(AccessService.MODULE_MANAGE_ACCOUNTS)) {
        return <AdAccountList/>;
    } else {
        return t('default.no_module_access');
    }
};
